export default "__VITE_ASSET__4642d40a__"